import React from 'react';
import classnames from 'classnames';
import GoogleAnalyticsConstants from '~/constants/google-analytics-constants';

export interface Props {
  href: string;
  trackingLabel: string;
  className?: string;
  id?: string;
  useNoreferrer?: boolean;
  onClick?(): void;
}

const LinkBlankTarget: React.FC<Props> = ({
  children,
  className,
  href,
  useNoreferrer = true,
  trackingLabel,
  onClick,
  id,
}) => {
  return (
    // eslint-disable-next-line react/jsx-no-target-blank
    <a
      className={className}
      target="_blank"
      href={href}
      id={id}
      onClick={onClick}
      rel={classnames('noopener', { noreferrer: useNoreferrer })}
      data-trackingcategory={GoogleAnalyticsConstants.categories.EXTERNAL_LINK}
      data-trackingaction={GoogleAnalyticsConstants.actions.NAVIGATE}
      data-trackinglabel={trackingLabel || 'LinkBlankTarget'}
    >
      {children}
    </a>
  );
};

export default LinkBlankTarget;
